module.exports = __webpack_public_path__ + "static/img/shop_environ_1.27100814.jpg";